import React from 'react';
import { CARD_LONG as W, CARD_SHORT as H } from '../../catalog';
import { V, T, Svg, Circle } from '../primitives';
import { CardFaceProps, Logo, Photo, Validity, faceBase, faceData, nameStyle, type } from './shared';
import { shade } from '../cardColors';

const PANEL = 84;

/** Sidebar — the photo on a colour panel; the first detail sits beneath it
 *  as a badge, the rest beside it. */
const SidebarFront: React.FC<CardFaceProps> = (props) => {
  const { design, person, photo, school, validUntil } = props;
  const { palette, details } = faceData(props);
  const [featured, ...rest] = details;
  return (
    <V style={[faceBase(W, H, palette.paper), { flexDirection: 'row' }]}>
      {/* Panel */}
      <V style={{ width: PANEL, height: H, backgroundColor: palette.primary, alignItems: 'center', paddingTop: 10 }}>
        <Svg width={PANEL} height={H} viewBox={`0 0 ${PANEL} ${H}`} style={{ position: 'absolute', left: 0, top: 0 }}>
          <Circle cx={-6} cy={H + 8} r={58} fill={palette.primaryDeep} opacity={0.6} />
          <Circle cx={PANEL + 18} cy={-14} r={40} fill={palette.accent} opacity={0.16} />
        </Svg>
        <Logo school={school} size={22} palette={palette} tile round />
        <Photo photo={photo} name={person.name} width={58} height={70} radius={5} palette={palette}
          ring={{ width: 2, color: palette.paper }} style={{ marginTop: 8 }} />
        {featured && (
          <V style={{ marginTop: 7, paddingHorizontal: 7, paddingVertical: 2.5, borderRadius: 8, backgroundColor: palette.accent, alignItems: 'center', maxWidth: PANEL - 12 }}>
            <T style={[type.mono, { fontSize: 6.2, color: palette.onAccent }]} lines={1}>{featured.value}</T>
          </V>
        )}
        {featured && <T style={[type.label, { color: palette.onPrimaryMuted, marginTop: 2.5 }]}>{featured.label}</T>}
      </V>
      <V style={{ width: 2.4, height: H, backgroundColor: palette.accent }} />

      {/* Details */}
      <V style={{ flex: 1, paddingHorizontal: 11, paddingTop: 11 }}>
        <T style={{ fontSize: 7.4, fontWeight: 700, color: palette.primaryText, letterSpacing: -0.1 }} lines={2}>{school.name}</T>
        <T style={[type.caps, { fontSize: 4.3, color: shade(palette.accent, 0.35), marginTop: 2 }]} lines={1}>{design.title}</T>
        <V style={{ height: 0.7, backgroundColor: palette.hairline, marginTop: 6, marginBottom: 6 }} />
        <T style={[nameStyle(person.name, 10.8), { color: palette.ink, marginBottom: 6 }]} lines={2}>{person.name}</T>
        {rest.map((d, i) => (
          <V key={i} style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 3.4 }}>
            <T style={[type.label, { width: 50, paddingRight: 4, color: palette.inkFaint }]}>{d.label}</T>
            <T style={[type.value, { flex: 1, color: palette.ink }, d.mono ? type.mono : {}]} lines={1}>{d.value}</T>
          </V>
        ))}
        <V style={{ position: 'absolute', left: 11, right: 11, bottom: 8 }}>
          <Validity validUntil={validUntil} color={palette.ink} labelColor={palette.inkFaint} />
        </V>
      </V>
    </V>
  );
};

export default SidebarFront;
